'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React, { useState } from 'react'

// walrus
import Box from '@components/kit/box'
import Header from '@components/kit/header'
import Tabs, { Tab } from '@components/kit/tabs'

// lib
import AppShell from '@components/ui/app-shell'
import PageHeader from '@components/ui/page-header'
import ByCompany from './by-company/by-company.web'

/* -----------------------------------------------------------------------------
 * Members
 * -------------------------------------------------------------------------- */

enum TabType {
  BY_COMPANY = 'by_company'
}

function Members() {
  const [activeTab, setActiveTab] = useState<TabType>(TabType.BY_COMPANY)

  return (
    <AppShell activePage='members' label='Members'>
      <PageHeader eyebrow='Clinical operations' title='Members' />

      <Header
        bg='transparent'
        headerLeft={
          <Tabs>
            <Tab
              active={activeTab === TabType.BY_COMPANY}
              bg='transparent'
              onPress={() => setActiveTab(TabType.BY_COMPANY)}
            >
              By Company
            </Tab>
          </Tabs>
        }
      />

      <Box>{activeTab === TabType.BY_COMPANY && <ByCompany />}</Box>
    </AppShell>
  )
}

export default Members
